import meetup1 from '../imgs/meetup1.png';
import meetup2 from '../imgs/meetup2.png';
import meetup3 from '../imgs/meetup3.jpg';
// import eventsherenow from '../imgs/eventsherenow.png';
// import yardland from '../imgs/yardland.png';
import chvenue from '../imgs/chvenue.png';
import crbc from '../imgs/crbc.png';
import valuableMobile from '../imgs/valuable-mobile.PNG';
import valuableMobile2 from '../imgs/valuable-moblile2.PNG';
import valuableMobile3 from '../imgs/valuable-mobile3.PNG';
import valuableMobile4 from '../imgs/valuable-mobile4.PNG';

import { meetup, chvenue as chvenueTech, EventsHereNow, yardland as yardlandTech, CRBC, valuable as valuableTech } from '../data/techItems';

export const projectsData = [
    {
        images: [valuableMobile, valuableMobile2, valuableMobile3, valuableMobile4],
        title: "Valuable",
        description: "A collectibles and high-value asset valuation platform with AI-powered pricing, real-time sync, and native iOS/Android apps built with Swift and Kotlin.",
        techs: valuableTech,
        liveLink: "https://app.valuable.app/",
        appStoreLink: "https://apps.apple.com/us/app/valuable-app/id6670316366",
        playStoreLink: "https://play.google.com/store/apps/details?id=app.valuable"
    },
    {
        images: [crbc],
        title: "CRBC",
        description: "An informational site for a local church.",
        techs: CRBC,
        codeLink: "https://github.com/ndyarborough/creedmoorroadbaptist",
        liveLink: "https://crbc-d0e3f.web.app/"
    },
    {
        images: [meetup3, meetup1, meetup2],
        title: "MeetUp",
        description: "Full-Stack social media application designed for mobile platforms.",
        techs: meetup,
        codeLink: "https://github.com/ndyarborough/Meetup_2.0"
    },
    {
        images: [chvenue],
        title: "CH Venue",
        description: "Landing page built to show my ability to go from a design to a real application.",
        techs: chvenueTech,
        codeLink: "https://github.com/ndyarborough/chvenue",
        liveLink: "https://ndyarborough.github.io/chvenue"
    },
    // {
    //     images: [yardland],
    //     title: "YardLand 🪴",
    //     description: "A small, but functional website for a landscaping business.",
    //     techs: yardlandTech,
    //     codeLink: "https://github.com/ndyarborough/yardland",
    //     liveLink: "https://ndyarborough.github.io/yardland"
    // },
    // {
    //     images: [eventsherenow],
    //     title: "Events Here Now 🗓️",
    //     description: "Tied Google Maps and TicketMaster APIs together to create a powerful application.",
    //     techs: EventsHereNow,
    //     codeLink: "https://github.com/ndyarborough/Events-Here-Now",
    //     liveLink: "https://ndyarborough.github.io/Events-Here-Now/index.html"
    // },
   
];